import { useTheme } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends, a as _objectSpread2 } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import Icon from '../../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../ErrorLabel/ErrorLabel.js';
import '../../FormItem/FormItem.js';
import '../../Input/Input.js';
import '../../InputLabel/InputLabel.js';
import TextInput from '../../TextInput/TextInput.js';
import InputAddon from '../../InputAddon/InputAddon.js';

const _excluded = ["styles"];
const SearchField = _ref => {
  let {
      styles = {}
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/createElement(TextInput, _extends({
    styles: _objectSpread2(_objectSpread2({}, styles), {}, {
      root: _objectSpread2({
        flex: 2,
        mr: `${theme.spacing.xxs}px`
      }, styles.root)
    }),
    size: "small",
    name: "sideMenuSearch",
    autoComplete: "off",
    startInputAddon: /*#__PURE__*/createElement(InputAddon, {
      position: "start",
      styles: {
        root: {
          top: '8px'
        }
      }
    }, /*#__PURE__*/createElement(Icon, {
      glyph: icons.SEARCH
    }))
  }, rest));
};

export default SearchField;
